<div class="relative h-full">
  <button
    app-icon-button
    (click)="onClose()"
    app-tooltip
    tooltip="Cancelar"
    class="absolute! right-px top-px block rounded-md rounded-br-none rounded-tl-none border-0 bg-base-whisper-500 shadow"
  >
    <svg-icon
      class="flex h-8 w-8 text-base-whisper-900 group-hover:text-theme-contrast"
      src="assets/icons/icon-close.svg"
    ></svg-icon>
  </button>
  <app-upload-file [config]="config" (statusChange)="onUpload($event)"></app-upload-file>
</div>
